import { render, staticRenderFns } from "./NewBasePushNotificationForm.vue?vue&type=template&id=bc48a772&scoped=true&"
import script from "./NewBasePushNotificationForm.vue?vue&type=script&lang=js&"
export * from "./NewBasePushNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./NewBasePushNotificationForm.vue?vue&type=style&index=0&id=bc48a772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc48a772",
  null
  
)

export default component.exports